export type CompletedFileRow = {
  filePath: string
  displayPath?: string | null
  url?: string | null
  status?: 'new' | 'modified'
  linesAdded: number
  linesRemoved: number
  documentId?: string
  timestamp?: string
  title?: string
  changeStatus?: string
}

type CompletedFileKey = {
  filePath: string
  documentId?: string
}

/** Upsert by filePath or documentId - mirrors recordTouchedFile persist coalesce. */
export function upsertCompletedFile<T extends CompletedFileKey>(
  prev: T[],
  file: T,
): T[] {
  const idx = prev.findIndex(
    (f) =>
      f.filePath === file.filePath ||
      (!!file.documentId && f.documentId === file.documentId),
  )
  if (idx >= 0) {
    const next = [...prev]
    next[idx] = { ...next[idx], ...file }
    return next
  }
  return [...prev, file]
}

/** Fold completed file rows into one entry per filePath or documentId. */
export function coalesceCompletedFiles<T extends CompletedFileKey>(
  files: T[],
): T[] {
  return files.reduce(
    (acc, file) => upsertCompletedFile(acc, file),
    [] as T[],
  )
}
